import * as React from 'react';
import { registerComponent } from '@avensia/excite';
import BaseProductListingPage from './BaseProductListingPage';

export default registerComponent<NordicNest.Api.ProductListingPageApiModel>(props => (
  <BaseProductListingPage {...props} />
));
